import { Skeleton } from '@chakra-ui/react'
import Tracking from 'lodestar-app-element/src/components/common/Tracking'
import { useApp } from 'lodestar-app-element/src/contexts/AppContext'
import { useResourceCollection } from 'lodestar-app-element/src/hooks/resource'
import { useTracking } from 'lodestar-app-element/src/hooks/tracking'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { commonMessages, productMessages } from '../../helpers/translation'
import { usePublishedProgramCollection } from '../../hooks/program'
import { ReactComponent as AngleRightIcon } from '../../images/angle-right.svg'
import { SectionTitle, StyledLink } from '../../pages/AppPage'
import ProgramCard from '../program/ProgramCard'

const StyledSection = styled.section`
  background-color: #fff;
  padding-bottom: 80px;
`

const StyledAngleRightIcon = styled(AngleRightIcon)`
  display: inline-block;
`

const ProgramSection: React.FC<{ options: { title?: string; colAmount?: number; categoryId?: string } }> = ({
  options,
}) => {
  const { formatMessage } = useIntl()
  const tracking = useTracking()

  const { id: appId } = useApp()
  const { loadingPrograms, errorPrograms, programs } = usePublishedProgramCollection({
    isPrivate: false,
    categoryId: options?.categoryId,
  })
  const { resourceCollection } = useResourceCollection(
    programs.slice(0, options?.colAmount || 3).map(program => `${appId}:program:${program.id}`),
    true,
  )

  if (loadingPrograms)
    return (
      <div className="container mb-5">
        <Skeleton height="20px" my="10px" />
        <Skeleton height="20px" my="10px" />
        <Skeleton height="20px" my="10px" />
      </div>
    )

  if (programs.length === 0 || errorPrograms) return null

  return (
    <StyledSection className="page-section">
      <Tracking.Impression resources={resourceCollection} ignore={'CUSTOM'} />

      <SectionTitle>{options?.title || formatMessage(productMessages.program.content.onlineCourse)}</SectionTitle>

      <div className="container mb-2">
        <div className="row">
          {programs.slice(0, options?.colAmount || 3).map((program, idx) => (
            <div
              key={program.id}
              className={`col-12 col-lg-${(options?.colAmount && 12 / options?.colAmount) || 4} mb-2`}
            >
              <ProgramCard
                program={program}
                withMeta
                noInstructor
                onClick={() => {
                  const resource = resourceCollection[idx]
                  resource && tracking.click(resource, { position: idx + 1 })
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="text-center">
        <StyledLink to={`/programs${options?.categoryId ? '?active=' + options?.categoryId : ''}`}>
          {formatMessage(commonMessages.defaults.more)}
          <StyledAngleRightIcon />
        </StyledLink>
      </div>
    </StyledSection>
  )
}

export default ProgramSection
